module.exports = __webpack_public_path__ + "img/background-todos.8145917d.png";